import * as modules from "./modules";

import { IState } from "./IState";
import Vue from "vue";
import Vuex from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

Vue.use(Vuex);

export function getStore() {
  const state = ({
    currentSession: undefined,
    logoPaths: {},
  } as unknown) as IState;

  const store = new Vuex.Store<IState>({
    modules,
    actions,
    getters,
    mutations,
    state,
    // eslint-disable-next-line
    strict: false, //app.nodeEnv === 'development'
  });

  //store._devtoolHook.on('vuex:error', errorHandler)
  return store;
}
